import {
    Button,
    Col,
    EditButton,
    Form,
    getDefaultSortOrder,
    Icons,
    Input,
    List,
    Row,
    Space,
    Table,
    TextField,
    useTable,
} from '@pankod/refine-antd';
import { CrudFilters, IResourceComponentsProps, useTranslate } from '@pankod/refine-core';
import { ButtonExport } from 'components/buttonExport';
import useMediaScreen from 'hooks/useMediaScreen';
import React from 'react';
import { ITrackKey, ITrackKeyResponse } from 'types/trackkey.interface';
import { getOrderNumber } from 'utils';

export const TrackKeyList: React.FC<IResourceComponentsProps> = () => {
    const t = useTranslate();
    const { isMobile } = useMediaScreen();
    const { tableProps, sorter, searchFormProps }: any = useTable<ITrackKeyResponse>({
        resource: 'track-keys',
        initialPageSize: 100,
        onSearch: (params) => {
            const filters: CrudFilters = [];
            const input = params;
            filters.push({
                field: 'search',
                operator: 'in',
                value: input,
            });
            return filters;
        },
    });
    const current = tableProps?.pagination?.current;
    const pageSize = tableProps?.pagination?.pageSize;

    return (
        <List>
            <Row style={{ display: 'block' }}>
                <Col>
                    <Form layout='vertical' {...searchFormProps}>
                        <Form.Item label='Search' name='search' style={{ width: isMobile ? '100%' : '50%' }} initialValue=''>
                            <Input placeholder='MusicKey, CamelotKey' prefix={<Icons.SearchOutlined />} />
                        </Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Form.Item>
                                <Button htmlType='submit' type='primary'>
                                    Filter
                                </Button>
                            </Form.Item>
                            <ButtonExport path='track-keys' />
                        </div>
                    </Form>
                </Col>
                <Col>
                    <Table
                        {...tableProps}
                        pagination={{
                            ...tableProps?.pagination,
                            showSizeChanger: true,
                        }}
                        rowKey='id'
                    >
                        <Table.Column
                            dataIndex='_id'
                            key='_id'
                            title='Index'
                            render={(value, item, index) => <TextField value={getOrderNumber(current, pageSize, index)} />}
                        />
                        <Table.Column
                            dataIndex='musicKey'
                            key='musicKey'
                            title='MusicKey'
                            render={(value) => <TextField value={value} />}
                            defaultSortOrder={getDefaultSortOrder('musicKey', sorter)}
                            sorter
                        />
                        <Table.Column
                            dataIndex='camelotKey'
                            key='camelotKey'
                            title='CamelotKey'
                            render={(value) => <TextField value={value} />}
                            defaultSortOrder={getDefaultSortOrder('camelotKey', sorter)}
                            sorter
                        />

                        <Table.Column<ITrackKey>
                            title={t('table.actions')}
                            dataIndex='actions'
                            render={(_, record) => (
                                <Space>
                                    <EditButton hideText size='small' recordItemId={record._id} />
                                    {/* <DeleteButton hideText size='small' recordItemId={record._id} /> */}
                                </Space>
                            )}
                        />
                    </Table>
                </Col>
            </Row>
        </List>
    );
};
